import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { CartItem } from '@/types/cart';

import { ReservationFormData } from './reservation-store';

export interface ReservationResult {
  reservationNumber: string;
  publicToken: string | null;
  items: CartItem[];
  formData: ReservationFormData;
  totalAmount: number;
  pickupDateTime: string; // ISO string format
  createdAt: Date;
  // 입금 정보 (임시로 하드코딩, 나중에 백엔드에서 받아올 예정)
  paymentInfo: {
    bankName: string;
    accountNumber: string;
    accountHolder: string;
  };
}

interface ReservationResultState {
  currentReservation: ReservationResult | null;
  setReservation: (
    items: CartItem[],
    formData: ReservationFormData,
    totalAmount: number,
    reservationNumber: string,
    pickupDateTime: string,
    publicToken?: string
  ) => void;
  clearReservation: () => void;
}

export const useReservationResultStore = create<ReservationResultState>()(
  persist(
    set => ({
      currentReservation: null,

      setReservation: (items, formData, totalAmount, reservationNumber, pickupDateTime, publicToken) => {
        const reservation: ReservationResult = {
          reservationNumber,
          publicToken: publicToken ?? null,
          items: [...items], // 깊은 복사
          formData: { ...formData }, // 깊은 복사
          totalAmount,
          pickupDateTime,
          createdAt: new Date(),
          paymentInfo: {
            bankName: '신한',
            accountNumber: '110-449-763078',
            accountHolder: '신현욱',
          },
        };

        set({ currentReservation: reservation });
      },

      clearReservation: () => {
        set({ currentReservation: null });
      },
    }),
    {
      name: 'reservation-result-storage',
      partialize: state => ({ currentReservation: state.currentReservation }),
    }
  )
);
